<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-24 13:38:04
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-03-25 15:39:50
-->
<template>
	<el-form :model="formData" label-width="130px" ref="form" :rules="rules">
		<el-form-item label="佣金率不低于" prop="commission_rate">
			<el-input
				v-model="formData['commission_rate']"
				placeholder="请输入1-50的数字"
				style="width: 400px"
				@input="val => change('commission_rate', val)"
			>
				<template slot="append">%</template>
			</el-input>
		</el-form-item>
		<el-form-item label="服务费率不低于" prop="service_rate">
			<el-input v-model="formData['service_rate']" placeholder="请输入0-40的数字" style="width: 400px" @input="val => change('service_rate', val)">
				<template slot="append">%</template>
			</el-input>
		</el-form-item>
		<el-form-item label="预估单品成交" prop="estimated_single_sale">
			<el-input
				v-model="formData['estimated_single_sale']"
				placeholder="请输入单品预估成交金额"
				style="width: 400px"
				@input="val => change('estimated_single_sale', val)"
			>
				<template slot="prepend">¥</template>
			</el-input>
		</el-form-item>
	</el-form>
</template>
<script>
import { isServiceRate, isValidNoZeroPriceReg } from '@/utils/reg';
import mixin from '../../mixin';
export default {
	name: 'CoopPriceForm',
	mixins: [mixin],
	data() {
		const _reg = /^(([1-9])|([1-4]\d)|50)$/;
		const validator1 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('佣金率不可为空'));
			} else if (!_reg.test(value)) {
				callback(new Error('佣金率错误，请输入1-50的数字'));
			} else {
				callback();
			}
		};
		const validator2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('服务费率不可为空'));
			} else if (!isServiceRate.test(value)) {
				callback(new Error('服务费率只能为0-40的数字'));
			} else {
				callback();
			}
		};
		const validator3 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('单品预估成交金额不可为空'));
			} else if (!isValidNoZeroPriceReg.test(value) && +value !== 0) {
				callback(new Error('单品预估成交金额只能为数字'));
			} else {
				callback();
			}
		};
		return {
			formData: {
				commission_rate: '',
				service_rate: '',
				estimated_single_sale: '',
			},
			rules: {
				commission_rate: [{ validator: validator1, triggle: 'blur' }],
				service_rate: [{ validator: validator2, triggle: 'blur' }],
				estimated_single_sale: [{ validator: validator3, triggle: 'blur' }],
			},
		};
	},
	methods: {
		validate() {
			return new Promise((resolve, reject) => {
				this.$refs.form.validate(valid => {
					if (valid) {
						resolve(this.formData);
					} else {
						reject(valid);
						return false;
					}
				});
			});
		},
		resetForm() {
			this.$refs.form.resetFields();
		},
		isFormModified() {
			return this.isModified;
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-input-group__append,
/deep/ .el-input-group__prepend {
	border: 1px solid #e3e3e3;
}
/deep/ .el-input-group__append {
	border-left: none;
}
/deep/ .el-input-group__prepend {
	border-right: none;
}
</style>